const step_up = {
    verify_your_identity: 'Verifica la tua identità',
    choose_method_description: 'Per continuare, conferma la tua identità con uno dei seguenti metodi.',
    password: 'Password',
    password_description: 'Inserisci la password del tuo account',
    enter_password_description: 'Inserisci la password del tuo account per continuare.',
    enter_verification_code_description: 'Inserisci il codice di verifica inviato a {{identifier}}.',
    subject_proof_description: 'Per continuare, conferma la tua identità tramite un account collegato al tuo. Potrai poi configurare un metodo di verifica.',
    no_method_available: 'Nessun metodo di verifica disponibile',
    no_method_available_description: 'Il tuo account non dispone di alcun metodo in grado di completare questa verifica. Contatta il tuo amministratore per ricevere assistenza.',
};
export default Object.freeze(step_up);
